module.exports = __webpack_public_path__ + "img/logo.ee3eb1f1.png";